import { render, staticRenderFns } from "./input-search.vue?vue&type=template&id=6f81de96&scoped=true&"
import script from "./input-search.vue?vue&type=script&lang=ts&"
export * from "./input-search.vue?vue&type=script&lang=ts&"
import style0 from "./input-search.vue?vue&type=style&index=0&id=6f81de96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f81de96",
  null
  
)

export default component.exports